import Pagination from './Pagination.jsx';

export default Pagination;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/SearchResults/Pagination/index.js